"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CryptoUtils = void 0;
var _core = _interopRequireDefault(require("crypto-js/core"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var UUID_V4_TEMPLATE = '10000000-1000-4000-8000-100000000000';
var CryptoUtils = /*#__PURE__*/ function() {
    function CryptoUtils() {
        _class_call_check(this, CryptoUtils);
    }
    _create_class(CryptoUtils, null, [
        {
            key: "_randomWord",
            value: function _randomWord() {
                var _core_default_lib_WordArray_random_words_;
                return (_core_default_lib_WordArray_random_words_ = _core.default.lib.WordArray.random(1).words[0]) !== null && _core_default_lib_WordArray_random_words_ !== void 0 ? _core_default_lib_WordArray_random_words_ : 0;
            }
        },
        {
            key: "generateUUIDv4",
            value: function generateUUIDv4() {
                var uuid = UUID_V4_TEMPLATE.replace(/[018]/g, function(c) {
                    return(// eslint-disable-next-line no-bitwise -- Crypto utility
                    (+c ^ CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
                });
                return uuid.replaceAll(/-/g, '');
            }
        },
        {
            key: "generateCodeVerifier",
            value: function generateCodeVerifier() {
                return CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4();
            }
        },
        {
            key: "generateCodeChallenge",
            value: function generateCodeChallenge(codeVerifier) {
                var hashed = (0, _sha.default)(codeVerifier);
                return _encBase.default.stringify(hashed).replaceAll(/\+/g, '-').replaceAll(/\//g, '_')// eslint-disable-next-line no-div-regex -- Crypto utility
                .replaceAll(/=+$/g, '');
            }
        }
    ]);
    return CryptoUtils;
}();
exports.CryptoUtils = CryptoUtils; //# sourceMappingURL=CryptoUtils.js.map
